
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

export default {
components: {
Loading,
XHeader,
XButton,
Group,
Checker,
CheckerItem,
XTextarea,
Icon
},
data () {
return {
loading: true,
type: 0,
orgInfoType: 'fund', // 募集机构类型 orgType，fund:基金，futures：期货资管
data: {
isFollowProduct: {
checked: ''
},
orgAssetSize: {
checked: ''
},
isControllingShareholder: {
checked: '',
description: ''
},
transactionActualBeneficiary: {
checked: '',
description: ''
},
isBadFaith: {
checked: '',
description: ''
}
}
}
},
computed: {

isFund () {
return this.orgInfoType !== 'futures'
}
},
created () {
this.$vux.loading.show({text: '加载中'})
this.$bridge.registerHandler('getUpdate', this.$_product_update)
this.$_product_init()
},
methods: {
$_product_update () {
this.type = 1
},
$_product_init () {
let _this = this
setTimeout(() => {
_this.data.isFollowProduct.checked = parseInt(this.$route.query.isNormal) === 1 ? '否' : '是'
_this.type = parseInt(this.$route.query.type)
_this.orgInfoType = this.$route.query.orgInfoType
if (_this.$route.query.oldInfo) {
let res = JSON.parse(this.$route.query.oldInfo)
_this.data = {
isFollowProduct: {
checked: JSON.parse(res.isFollowProduct).checked
},
orgAssetSize: {
checked: JSON.parse(res.orgAssetSize).checked
},
isControllingShareholder: {
checked: JSON.parse(res.isControllingShareholder).checked,
description: JSON.parse(res.isControllingShareholder).description
},
transactionActualBeneficiary: {
checked: JSON.parse(res.transactionActualBeneficiary).checked,
description: JSON.parse(res.transactionActualBeneficiary).description
},
isBadFaith: {
checked: JSON.parse(res.isBadFaith).checked,
description: JSON.parse(res.isBadFaith).description
}
}
}
_this.loading = false
_this.$vux.loading.hide()
}, 500)
},
$_product_submit () {
for (var item in this.data) {
if (this.data[item].checked === '') {
this.$vux.toast.show({
type: 'warn',
text: '选择为空或输入不合规范'
})
return
}
let isControllingShareholder = item === 'isControllingShareholder' && this.data[item].checked === '是' && this.data[item].description === ''
let transactionActualBeneficiary = item === 'transactionActualBeneficiary' && this.data[item].checked === '其他机构或个人' && this.data[item].description === ''
let isBadFaith = item === 'isBadFaith' && this.data[item].checked === '是' && this.data[item].description === ''
if (isControllingShareholder || transactionActualBeneficiary || isBadFaith) {
this.$vux.toast.show({
type: 'warn',
text: '请输入说明内容'
})
return
}
}
this.$_product_commit(Object.assign({}, this.data, this.$route.query))
},
$_product_commit (json) {
delete json.oldInfo
delete json.type
delete json.isNormal
if (this.isDev) {
console.log(JSON.stringify(json))
} else {
this.$bridge.callHandler('getResult', {message: '最后确认', json: JSON.stringify(json)}, function (data) {
console.log('submit')
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Product/Question.vue